import { format } from 'date-fns'

export function formatHour(local_start_date, local_start_time) {
  return format(
    Date.parse(`${local_start_date}T${local_start_time}`),
    'h:mm aa ·'
  )
}
